import ModalAdmin from 'components/molecules/admin/ModalAdmin'
import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { Box, CircularProgress } from '@mui/material'
import CustomButton from 'components/atoms/CustomButton'
import { ChevronLeft } from '@mui/icons-material'
import { getNewParamsForSubscription, getTiersList } from 'api'
import { z } from 'zod'
import { useMutation, useQuery } from 'react-query'
import { useTranslation } from 'react-i18next'
import { Card, Divider, InputNumber, Radio, Slider, Space, Switch } from 'antd'
// import SelectFields from 'components/molecules/SelectFields'
import EuroIcon from '@mui/icons-material/Euro'
import { useSelector } from 'react-redux'
import { ROLE_SUPER_ADMIN, SUBSCRIPTION_TYPES, PAYMENT_TYPES, SUBSCRIPTION_STATUS } from 'constant'



const ChangePlanModal = ({
  show,
  onClose,
  onSubmit,
  currentPlan,
  onCancelPlan,
  onReactivatePlan,
  loading,
  token,
  companyId
}) => {
  const role = useSelector((state) => state.admin.role)
  const [tiers, setTiers] = useState([])
  const [currentStep, setCurrentStep] = useState({
    step: 0,
    needValidate: false
  })
  const { t } = useTranslation()
  const [custom, setCustom] = useState(false)
  const [customPrice, setCustomPrice] = useState(currentPlan?.custom_price || 0)
  const [newParams, setNewParams] = useState({
    'is_custom': true,
    'price_per_seat': 0,
    'billing_period': 'MONTHLY',
    'next_payment_date': null,
    'expired_at_date': null,
    'new_amount': 0,
    'new_discount': 0,
    'new_tax': 0,
    'new_total': 0,
    'new_users': 0,
    'new_user_day_to_pay': 0,
    'user_to_deactivate': 0,
    'old_user_to_reactivate': 0,
    'new_user_amount': 0,
    'new_user_discount': 0,
    'new_user_tax': 0,
    'new_user_total': 0
  })


  const [subscription_type, setSubscriptionType] = useState(SUBSCRIPTION_TYPES.MONTHLY)
  const [payment_type, setPayment_type] = useState(PAYMENT_TYPES.PLATFORM)


  const steps = [
    {
      id: '1',
      name: custom ? t('Plans.EditCustomPlan') : t('Plans.Change subscription'),
      optional: false,
      fields: [
        'seat_number',
        'subscription_type',
        'set_as_payed',
        'is_custom',
        'price_for_custom'
      ],
      schema: z.object({
        seat_number: z.number().min(1, { message: 'seat_number is required' }),
        subscription_type: z
          .string(),
        set_as_payed:
          z.boolean(),
        is_custom: z.boolean(),
        price_for_custom: z.number().superRefine((data, ctx) => {
          if (ctx?.parent && ctx.parent.is_custom && data <= 0) {
            ctx.addIssue({
              code: z.ZodIssueCode.custom,
              message: 'price_for_custom is required'
            })
          }
        })
      })
    }
  ]

  const defaultValues = {
    seat_number: 1,
    subscription_type: 'MONTHLY',
    set_as_payed: false,
    is_custom: false,
    price_for_custom: 1
  }

  const [values, setDefaultValues] = useState(defaultValues)

  const {
    handleSubmit,
    reset,
    trigger,
    getValues,
    setValue,
    control,
    formState: { errors, isValid },
    watch
  } = useForm({
    mode: 'onChange',
    resolver: zodResolver(steps[currentStep?.step]?.schema),
    defaultValues: values,
    values: values
  })
  const sits = watch('seat_number')
  const price_for_custom = watch('price_for_custom')
  const set_as_payed = watch('set_as_payed')

  const marks = {
    0: {
      style: {
        fontSize: '12px',
        fontWeight: 400,
        color: '#828282',
        lineHeight: '20px',
        fontFamily: 'Inter',
        transform: 'translateX(-15%)'
      },
      label: 'Small'
    },
    4: {
      style: { fontSize: '12px', fontWeight: 400, color: '#828282', lineHeight: '20px', fontFamily: 'Inter' },
      label: 'Medium'
    },
    8: {
      style: { fontSize: '12px', fontWeight: 400, color: '#828282', lineHeight: '20px', fontFamily: 'Inter' },
      label: 'Large'
    },
    11: {
      style: {
        fontSize: '12px',
        fontWeight: 400,
        color: '#828282',
        lineHeight: '20px',
        fontFamily: 'Inter',
        transform: 'translateX(-90%)'
      },
      label: 'Custom'
    }
  }

  const selectedTier = tiers.find(
    (tier) => sits >= tier.min_seat && sits <= tier.max_seat
  )
  const maxSeats = tiers[tiers.length - 1]?.max_seat || 0

  const handleContactUs = () => {
    window.location.href = 'mailto:Info@legalai.it'
  }

  function closeModal() {
    reset()
    onClose()

  }

  const onChangeSubType = async (e) => {
    setSubscriptionType(e.target.value)
    setValue('subscription_type', e.target.value)
    await trigger('subscription_type', { shouldFocus: true })
  }

  const onChangePaymentType = async (e) => {

    setPayment_type(e.target.value)
    setValue('set_as_payed', e.target.value)
    e.target.value === PAYMENT_TYPES.PLATFORM ? setValue('set_as_payed', false) : setValue('set_as_payed', true)
    await trigger('set_as_payed', { shouldFocus: true })
  }

  const handleChangeSeats = async (val) => {
    setValue('seat_number', val)
    await trigger('subscription_type', { shouldFocus: true })
  }

  const onSetIsCustom = async (checked) => {
    setValue('is_custom', checked)
    setCustom(checked)
    if (checked && !currentPlan.is_custom) {
      setValue('price_for_custom', 1)
      setCustomPrice(1)
    }

  }

  const next = async () => {
    let values = getValues()
    onSubmit({
      ...values,
      ...(role !== ROLE_SUPER_ADMIN ? {
        is_custom: false,
        set_as_payed: false
      } : {})
    })

  }

  const prev = () => {
    setValue('is_custom', false)
    setValue('price_for_custom', 0)
    if (currentStep?.step > 0) {
      setCurrentStep((curr) => {
        return {
          step: curr.step - 1,
          needValidate: false
        }
      })
    }
  }

  function calcIva(price, aliquota = 22) {
    return price * (aliquota / 100)
  }

  const handleChangePrice = async (val) => {
    setValue('price_for_custom', val)
    setCustomPrice(val)
    await trigger('price_for_custom', { shouldFocus: true })

  }

  const handleCancelPlan = () => {
    onCancelPlan()
    closeModal()
  }

  const handleReactivatePlan = () => {
    onReactivatePlan()
    closeModal()
  }




  const getNewParams = useMutation({
    mutationKey: 'new-params-for-subscription',
    mutationFn: (values) => getNewParamsForSubscription(token, companyId, values),
    onSuccess: async (res) => {
      setNewParams(res?.resData?.data)
    },
    onError: (err) => {
      console.log(err)
      // showErrorMessage(t('error messages.Internal server error'))
    }
  })


  useQuery({
    queryKey: ['tiers'],
    refetchOnWindowFocus: false,
    queryFn: async () => {
      const res = await getTiersList()
      setTiers(res?.resData?.data?.sort((a, b) => a.id - b.id) || [])
    }
  })

  useEffect(() => {
    if (currentStep?.needValidate) {
      const fields = steps[currentStep?.step].fields
      trigger(fields, { shouldFocus: true })
    }
  }, [currentStep])


  useEffect(() => {
    if (currentPlan?.status !== SUBSCRIPTION_STATUS.CANCELED) {
      setValue('seat_number', currentPlan?.seat_number)
      setValue('set_as_payed', (!currentPlan?.next_payment_date && !currentPlan?.expired_at))
      setValue('is_custom', currentPlan?.is_custom)
      setValue('price_for_custom', currentPlan?.is_custom ? currentPlan?.custom_price : 1)
      setValue('subscription_type', currentPlan?.payment_type)
      setPayment_type((!currentPlan?.next_payment_date && !currentPlan?.expired_at) ? PAYMENT_TYPES.EXTERNAL : PAYMENT_TYPES.PLATFORM)
      setSubscriptionType(currentPlan?.payment_type)
      setCustom(currentPlan?.is_custom)
      setCustomPrice(currentPlan?.is_custom ? currentPlan?.custom_price : 1)
    }


  }, [currentPlan])


  useEffect(() => {

    if (!show) {
      return
    }

    if (token && companyId && currentPlan?.status !== SUBSCRIPTION_STATUS.CANCELED) {


      if (sits !== undefined && subscription_type !== undefined) {

        getNewParams.mutate({
          'seat_number': sits,
          'subscription_type': subscription_type,
          'is_custom': role === ROLE_SUPER_ADMIN ? custom : false,
          'price_for_custom': role === ROLE_SUPER_ADMIN ? price_for_custom : 0,
          'set_as_payed': role === ROLE_SUPER_ADMIN ? set_as_payed : false
        })
      }

    }

  }, [token, companyId, sits, custom, price_for_custom, set_as_payed, subscription_type, show])


  useEffect(() => {
    setDefaultValues(defaultValues)
  }, [])

  useEffect(() => {
    if (role !== ROLE_SUPER_ADMIN) {
      return
    }
    if (!currentPlan.is_custom && maxSeats > 0) {
      if (sits > maxSeats) {
        setValue('is_custom', true)
        setCustom(true)
      }
    }
  }, [sits])


  const monthlyPrice =
    custom ? getValues('price_for_custom') :
      subscription_type === 'MONTHLY' ? selectedTier?.price_per_seat_month : selectedTier?.price_per_seat_year
  const monthlyPricePerSits = monthlyPrice * sits
  const subTotal = subscription_type === 'MONTHLY' ? monthlyPricePerSits : (monthlyPricePerSits * 12)
  const total = calcIva(subTotal) + subTotal





  return (
    <ModalAdmin
      width={851}
      show={show}
      onClose={closeModal}
      title={
        <div className="flex flex-col">
          <span>{steps[currentStep?.step]?.name}</span>
          <div className="!font-thin !text-xs text-[#FFFFFF5C] flex justify-start items-center ">
            {currentStep?.step > 0 && (
              <div className="flex justify-start items-center -ml-2 cursor-pointer" onClick={prev}>
                <ChevronLeft />
              </div>
            )}{' '}

            {role === ROLE_SUPER_ADMIN && (
              <>

                STEP {currentStep?.step + 1} OF {steps.length}{' '}
                {steps[currentStep?.step]?.optional && '(optional)'}</>
            )}

          </div>

          {/*   <p className='text-xs font-normal mt-2	text-[rgba(255,255,255,0.65)]	'>{t('Plans.Subscription cycle')}</p> */}

        </div>
      }>
      <Box
        noValidate
        component="form"
        className={`flex flex-col min-h-[466px] justify-between`}
      >

        {role === ROLE_SUPER_ADMIN ||
          (!currentPlan?.is_custom &&
            (currentPlan.expired_at != null && currentPlan.next_payment_date != null)) ? (
          <>
            <div className="grid grid-cols-2 gap-4">

              {currentPlan?.status !== SUBSCRIPTION_STATUS.CANCELED && (
                <>
                  <div className="mt-2 mr-2" style={{ borderRight: '1px solid rgba(255, 255, 255, 0.20)' }}>


                    <div className="w-[300px]">
                      <p className="text-sm text-[#828282] font-normal mb-3">{t('Plans.ActiveSits')}</p>

                      <InputNumber
                        control={control}
                        min={1}
                        theme="admin"
                        errors={errors}
                        name={'seat_number'}
                        value={sits}
                        onChange={handleChangeSeats}
                        style={{
                          backgroundColor: 'rgba(255, 255, 255, 0.06)',
                          width: '100%',
                          borderRadius: '0px',
                          borderTopLeftRadius: '4px',
                          borderTopRightRadius: '4px',
                          borderBottomLeftRadius: '0px',
                          borderBottomRightRadius: '0px',
                          marginTop: -12,
                          border: '0px',
                          outline: 'none',
                          height: 38,
                          alignContent: 'center'
                        }}

                      />

                      <div>
                        <p className="text-sm text-[#828282] font-normal mt-4 mb-2">{t('Plans.Billing cycle')}</p>

                        <Radio.Group control={control} onChange={onChangeSubType} value={subscription_type} className="admin-plan-radio">
                          <Space direction="vertical" className="w-full">

                            <Radio value={SUBSCRIPTION_TYPES.MONTHLY} className="w-full">
                              <p className="text-white text-sm font-semibold">{t('Plans.Monthly')}</p>

                            </Radio>

                            <Radio value={SUBSCRIPTION_TYPES.YEARLY} className="w-full">


                              <p className="text-white text-sm font-semibold">{t('Plans.Yearly')}</p>


                            </Radio>

                          </Space>
                        </Radio.Group>
                      </div>


                      {role === ROLE_SUPER_ADMIN && (
                        <>
                          <div>
                            <p className="text-sm text-[#828282] font-normal mt-4 mb-2">{t('Plans.CustomPrice')}</p>
                            <Switch
                              disabled={sits > maxSeats}
                              style={{ backgroundColor: custom && '#0049EE' }}
                              checked={custom} onChange={onSetIsCustom} />

                            {custom && (<>
                              <p
                                className="text-sm text-[#828282] font-normal mt-4 mb-2">{subscription_type === SUBSCRIPTION_TYPES.MONTHLY ? t('Plans.MonthlyPrice') : t('Plans.YearlyPrice')}</p>

                              <InputNumber
                                min={1}
                                control={control}
                                theme="admin"
                                errors={errors}
                                name={'price_for_custom'}
                                suffix={<EuroIcon className="text-gray-500" />}
                                onChange={handleChangePrice}
                                defaultValue={getValues('price_for_custom')}
                                value={getValues('price_for_custom')}
                                style={{
                                  backgroundColor: 'rgba(255, 255, 255, 0.06)',
                                  width: '100%',
                                  borderRadius: '0px',
                                  borderTopLeftRadius: '4px',
                                  borderTopRightRadius: '4px',
                                  borderBottomLeftRadius: '0px',
                                  borderBottomRightRadius: '0px',
                                  border: '0px',
                                  outline: 'none',
                                  height: 38,
                                  alignContent: 'center'
                                }}

                              />

                              {errors.price_for_custom && (
                                <p className="text-red-500 text-xs mt-1">{errors?.price_for_custom?.message}</p>
                              )}
                            </>)}
                          </div>
                          <p
                            className="text-sm text-[#828282] font-normal mt-4 mb-2">{t('Plans.PlanPaymentMethod')}</p>
                          <Radio.Group control={control} onChange={onChangePaymentType} value={payment_type} className="admin-plan-radio">
                            <Space direction="vertical" className="w-full">

                              <Radio value={'PLATFORM'} className="w-full">
                                <p className="text-white text-sm font-semibold">{t('Plans.inPlatform')}</p>

                              </Radio>

                              <Radio value={'EXTERNAL'} className="w-full">

                                <p className="text-white text-sm font-semibold">{t('Plans.Externally')}</p>

                              </Radio>

                            </Space>
                          </Radio.Group>
                        </>
                      )}


                    </div>


                  </div>


                  <div className="mt-2">

                    <Card
                      className={`card-add-company rounded-lg transition-colors cursor-pointer bg-[#282828]  border-none`}
                      hoverable>

                      <div className="flex justify-between ">
                        <p className="text-white text-[13px] font-semibold">{t('Plans.New plan').toUpperCase()}</p>
                        <p className="font-normal text-[rgba(255, 255, 255, 0.70)] text-[14px]">
                          €{parseFloat(monthlyPrice).toFixed(2)}
                          <span className="text-[rgba(255, 255, 255, 0.70)]"> /{t('Plans.Month')}/user </span></p>
                      </div>

                      <div className="flex justify-between mt-1">
                        <p className="text-white text-[13px] font-semibold">{t('Plans.Sits')} ({sits})</p>
                        <p className="font-normal text-[rgba(255, 255, 255, 0.70)] text-[14px]">
                          €{parseFloat(monthlyPricePerSits).toFixed(2)}
                          <span className="text-[rgba(255, 255, 255, 0.70)]"> /{t('Plans.Month')} </span></p>
                      </div>

                      <div className="flex justify-between  mt-1">
                        <p className="text-white text-[13px] font-semibold">{t('Plans.Billing')}</p>
                        <p
                          className="font-normal text-[rgba(255, 255, 255, 0.70)] text-[14px]"> {subscription_type === SUBSCRIPTION_TYPES.MONTHLY ? t('Plans.Monthly') : t('Plans.Yearly')}</p>
                      </div>

                      <div className="flex justify-between  mt-1">
                        <p className="text-white text-[13px] font-semibold">{t('Plans.Payment')}</p>
                        <p
                          className="font-normal text-[rgba(255, 255, 255, 0.70)] text-[14px]"> {payment_type === PAYMENT_TYPES.PLATFORM ? t('Plans.inPlatform') : t('Plans.Externally')}</p>
                      </div>

                      <Divider style={{
                        backgroundColor: 'rgba(255, 255, 255, 0.20)',
                        marginTop: '12px',
                        marginBottom: '12px'
                      }} />

                      <p className="text-white text-[13px] font-semibold">{t('Plans.Discount tier')}</p>

                      <Slider
                        className="admin-slider"
                        min={0}
                        max={maxSeats + 1}
                        marks={marks}
                        defaultValue={custom ? maxSeats + 1 : Math.min(sits, maxSeats + 1)}
                        value={custom ? maxSeats + 1 : Math.min(sits, maxSeats + 1)}
                        disabled
                        tooltip={{ open: false }}
                        dotStyle={{ backgroundColor: '#94B1F4', width: '10px', height: '10px', marginTop: '-1px' }}
                        activeDotStyle={{
                          backgroundColor: '#0049EE',
                          width: '10px',
                          height: '10px',
                          marginTop: '-1px'
                        }}
                        styles={{
                          rail: { height: 4 },
                          tracks: { backgroundColor: '#0049EE', height: 4 }
                        }}
                      />

                    </Card>

                    <div className="mt-4">
                      <div className="flex justify-between">
                        <p className="text-xs font-normal text-[rgba(255, 255, 255, 0.65)]">Sub {t('Plans.Total')}</p>
                        <p className="text-xs font-normal text-[rgba(255, 255, 255, 0.65)]">

                          {parseFloat(subTotal).toFixed(2)}
                          €</p>
                      </div>

                      <div className="flex justify-between mt-2">
                        <p className="text-xs font-normal text-[rgba(255, 255, 255, 0.65)]">{t('Plans.VAT')}</p>
                        <p
                          className="text-xs font-normal text-[rgba(255, 255, 255, 0.65)]">{parseFloat(calcIva(subTotal)).toFixed(2)}€</p>

                      </div>

                      <Divider style={{ backgroundColor: 'rgba(255, 255, 255, 0.20)' }} />
                      <div className="flex justify-between mt-2">
                        <p className="text-sm font-semibold text-white">{t('Plans.Total')}</p>
                        <p className="text-sm font-semibold text-white">
                          {parseFloat(total).toFixed(2)} €
                        </p>
                      </div>

                      <Divider style={{ backgroundColor: 'rgba(255, 255, 255, 0.20)' }} />

                      <div className="flex justify-between mt-2">
                        <p className="text-sm font-semibold text-white">{t('Plans.ToPayNow')}</p>
                        <p className="text-sm font-semibold text-white">
                          {parseFloat(newParams.new_user_total).toFixed(2)} €
                        </p>
                      </div>


                    </div>


                  </div>
                </>
              )}


            </div>


            <div className={`flex gap-2 justify-end mt-8`}>

              <div className={`flex w-full justify-between`}>

                <div className="w-full">
                  {currentPlan?.status !== SUBSCRIPTION_STATUS.CANCELED && (currentPlan?.status === SUBSCRIPTION_STATUS.ACTIVE || currentPlan?.status === SUBSCRIPTION_STATUS.TRIAL) && (
                    <CustomButton className="max-w-max" buttonColor="danger" onClick={() => {
                      handleCancelPlan()

                    }}>
                      <div className="flex">

                        {t('Plans.Cancel subscription')}
                      </div>

                    </CustomButton>
                  )}

                  {currentPlan?.status === SUBSCRIPTION_STATUS.CANCELED && (
                    <CustomButton className="max-w-max" buttonColor="danger" onClick={() => {
                      handleReactivatePlan()

                    }}>
                      <div className="flex">

                        {t('Plans.Reactivate subscription')}
                      </div>

                    </CustomButton>
                  )}
                </div>

                <div className="flex w-full gap-2">
                  {currentPlan?.status !== SUBSCRIPTION_STATUS.CANCELED && (
                    <div className="w-full flex justify-between gap-2">
                      <CustomButton
                        buttonStyle={{
                          width: '100%'
                        }}
                        buttonColor="secondary" onClick={closeModal}>
                        {t('Cancel')}
                      </CustomButton>
                      {role !== ROLE_SUPER_ADMIN && sits > maxSeats ? (
                        <CustomButton
                          buttonStyle={{
                            width: '100%'
                          }}
                          onClick={() => {
                            handleContactUs()
                          }}
                        >
                          {t('Contact us')}
                        </CustomButton>
                      ) : (
                        <CustomButton
                          buttonStyle={{
                            width: '100%'
                          }}
                          onClick={next}
                          disabled={!isValid || loading}
                        >
                          {currentStep?.step < steps.length - 1 ? t('Continue') : t('Confirm')}
                          {loading && (<CircularProgress size="15px" style={{ marginLeft: 8, color: 'white' }} />)}
                        </CustomButton>
                      )}

                    </div>
                  )}
                </div>
              </div>


            </div>


          </>
        ) :
          (
            <>
              <div >
                <div className='h-[466px]'>Non puoi modificare o disdire in autonomia il tuo piano attuale </div>
                <div className='flex gap-2 justify-end'>
                  <CustomButton

                    buttonColor="secondary" onClick={closeModal}>
                    {t('Cancel')}
                  </CustomButton>
                  <CustomButton

                    onClick={() => {
                      handleContactUs()
                    }}
                  >
                    {t('Contact us')}
                  </CustomButton>
                </div>
              </div>

            </>





          )
        }


      </Box>
    </ModalAdmin>
  )
}

export default ChangePlanModal
